import { render, staticRenderFns } from "./EditVendorCategoryComponent.vue?vue&type=template&id=5be62657&"
import script from "./EditVendorCategoryComponent.vue?vue&type=script&lang=js&"
export * from "./EditVendorCategoryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports